
import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import FormHeader from "../common/FormHeader";
import "./formTitle.css";
import "./themePlaceholder.css";

function AccidentReport() {
  const sigCanvasRef = useRef(null);
  const [form, setForm] = useState({
    reportNo: "",
    personName: "",
    personAddress: "",
    personCity: "",
    personPostcode: "",
    personTelephone: "",
    personOccupation: "",
    reporterName: "",
    reporterAddress: "",
    reporterCity: "",
    reporterPostcode: "",
    reporterTelephone: "",
    reporterOccupation: "",
    accidentDate: "",
    accidentTime: "",
    accidentLocation: "",
    accidentDescription: "",
    injuryDetails: "",
    injuryDate: "",
    signature: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    const nextValue =
      name === "personTelephone" || name === "reporterTelephone"
        ? value.replace(/[^0-9]/g, "").slice(0, 12)
        : value;
    setForm({ ...form, [name]: nextValue });
  };

  const clearSignature = () => {
    sigCanvasRef.current.clear();
    setForm(prev => ({ ...prev, signature: "" }));
  };

  const saveSignature = () => {
    if (!sigCanvasRef.current.isEmpty()) {
      setForm(prev => ({
        ...prev,
        signature: sigCanvasRef.current.getTrimmedCanvas().toDataURL("image/png")
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Accident Report submitted!");
  };

  return (
    <div style={{ height: "100vh", overflowY: "auto", background: "#f5f7fa" }}>
      <FormHeader />
      <div className="container py-4">
       
        <div className="card shadow-sm rounded-4 p-4">
          <h2 className="text-center text-white py-2 mb-4 rounded" style={{ backgroundColor: "#8b1634", letterSpacing: "1px", fontSize: "1.8rem" }}>
            Accident Report
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-4">
              {/* Report No */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Enter Report No</label>
                <input type="text" className="form-control" name="reportNo" value={form.reportNo} onChange={handleChange} required placeholder="Enter Report No"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", fontSize: "1.08rem" }} />
              </div>
              {/* Section 1: About the person who had the accident */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold text-secondary">1. ABOUT THE PERSON WHO HAD THE ACCIDENT</h5>
              </div>
              <div className="col-md-4">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" name="personName" value={form.personName} onChange={handleChange} required placeholder="Name"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Address</label>
                <input type="text" className="form-control" name="personAddress" value={form.personAddress} onChange={handleChange} required placeholder="Address"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">City/Town</label>
                <input type="text" className="form-control" name="personCity" value={form.personCity} onChange={handleChange} required placeholder="City/Town"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Postcode</label>
                <input type="text" className="form-control" name="personPostcode" value={form.personPostcode} onChange={handleChange} required placeholder="Postcode"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Telephone</label>
                <input type="text" className="form-control" name="personTelephone" value={form.personTelephone} onChange={handleChange} required placeholder="Telephone" maxLength={12} inputMode="numeric" pattern="[0-9]*"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Occupation</label>
                <input type="text" className="form-control" name="personOccupation" value={form.personOccupation} onChange={handleChange} required placeholder="Occupation"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              {/* Section 2: Details of person reporting this accident */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold text-secondary">2. DETAILS OF PERSON REPORTING THIS ACCIDENT</h5>
              </div>
              <div className="col-md-4">
                <label className="form-label">Name</label>
                <input type="text" className="form-control" name="reporterName" value={form.reporterName} onChange={handleChange} required placeholder="Name"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Address</label>
                <input type="text" className="form-control" name="reporterAddress" value={form.reporterAddress} onChange={handleChange} required placeholder="Address"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">City/Town</label>
                <input type="text" className="form-control" name="reporterCity" value={form.reporterCity} onChange={handleChange} required placeholder="City/Town"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Postcode</label>
                <input type="text" className="form-control" name="reporterPostcode" value={form.reporterPostcode} onChange={handleChange} required placeholder="Postcode"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Telephone</label>
                <input type="text" className="form-control" name="reporterTelephone" value={form.reporterTelephone} onChange={handleChange} required placeholder="Telephone" maxLength={12} inputMode="numeric" pattern="[0-9]*"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Occupation</label>
                <input type="text" className="form-control" name="reporterOccupation" value={form.reporterOccupation} onChange={handleChange} required placeholder="Occupation"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              {/* Section 3: Details of accident/injury */}
              <div className="col-12 mt-3">
                <h5 className="fw-bold text-secondary">3. DETAILS OF ACCIDENT/INJURY</h5>
              </div>
              <div className="col-md-4">
                <label className="form-label">Date</label>
                <input type="date" className="form-control" name="accidentDate" value={form.accidentDate} onChange={handleChange} required placeholder="Date"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Time</label>
                <input type="time" className="form-control" name="accidentTime" value={form.accidentTime} onChange={handleChange} required placeholder="Time"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Where did the accident/injury take place?</label>
                <input type="text" className="form-control" name="accidentLocation" value={form.accidentLocation} onChange={handleChange} required placeholder="Location"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              <div className="col-md-12">
                <label className="form-label">Say how the accident happened, give details</label>
                <textarea className="form-control" name="accidentDescription" value={form.accidentDescription} onChange={handleChange} required placeholder="Description"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", minHeight: "60px" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Details of accident/injury</label>
                <textarea className="form-control" name="injuryDetails" value={form.injuryDetails} onChange={handleChange} required placeholder="Details of accident/injury"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe", minHeight: "60px" }} />
              </div>
              <div className="col-md-4">
                <label className="form-label">Date</label>
                <input type="date" className="form-control" name="injuryDate" value={form.injuryDate} onChange={handleChange} required placeholder="Date"
                  style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
              </div>
              {/* Signature */}
              <div className="col-md-4">
                <label className="form-label fw-semibold text-secondary">Signature</label>
                <div style={{ width: '100%', border: '2px solid #8b1634', borderRadius: '18px', background: '#e9cfd6', padding: '0.5rem', textAlign: 'left', position: 'relative', minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="#8b1634"
                    backgroundColor="#e9cfd6"
                    clearOnResize={false}
                    velocityFilterWeight={0.7}
                    minWidth={1}
                    maxWidth={2.5}
                    dotSize={1.5}
                    throttle={16}
                    canvasProps={{ width: window.innerWidth > 600 ? 350 : 300, height: 100, style: { width: '100%', height: '100px', border: 'none', borderRadius: '18px', background: '#e9cfd6', display: 'block', touchAction: 'none' } }}
                    onEnd={saveSignature}
                  />
                  <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                    <button type="button" className="btn btn-outline-danger btn-sm rounded-pill px-3" style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }} onClick={clearSignature}>Clear</button>
                  </div>
                </div>
              </div>
            {/* Section 4: Employers Use Only */}
            <div className="col-12 mt-4">
              <h5 className="fw-bold text-secondary">4. EMPLOYERS USE ONLY</h5>
              <div className="mb-2" style={{ fontWeight: 500, color: '#8b1634' }}>
                If this incident is reportable under <br />
                RIDDOR (Reporting of Injuries, Diseases and Dangerous Occurrences Regulations 1995)
              </div>
            </div>
            <div className="col-md-4">
              <label className="form-label">How was it reported?</label>
              <input type="text" className="form-control" name="employerReported" value={form.employerReported || ''} onChange={handleChange} placeholder="How was it reported?"
                style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Date</label>
              <input type="date" className="form-control" name="employerDate" value={form.employerDate || ''} onChange={handleChange} placeholder="Date"
                style={{ background: "#f7fafd", borderRadius: "10px", border: "1.5px solid #eaf0fe" }} />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-semibold text-secondary">Signature</label>
              <div style={{ width: '100%', border: '2px solid #8b1634', borderRadius: '18px', background: '#e9cfd6', padding: '0.5rem', textAlign: 'left', position: 'relative', minHeight: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <SignatureCanvas
                  ref={sigCanvasRef}
                  penColor="#8b1634"
                  backgroundColor="#e9cfd6"
                  clearOnResize={false}
                  velocityFilterWeight={0.7}
                  minWidth={1}
                  maxWidth={2.5}
                  dotSize={1.5}
                  throttle={16}
                  canvasProps={{ width: window.innerWidth > 600 ? 350 : 300, height: 100, style: { width: '100%', height: '100px', border: 'none', borderRadius: '18px', background: '#e9cfd6', display: 'block', touchAction: 'none' } }}
                  onEnd={saveSignature}
                />
                <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                  <button type="button" className="btn btn-outline-danger btn-sm rounded-pill px-3" style={{ background: 'transparent', color: '#8b1634', borderColor: '#8b1634' }} onClick={clearSignature}>Clear</button>
                </div>
              </div>
            </div>
            <div className="col-12 mt-3">
              <div style={{ color: '#6c757d', fontSize: '1rem', fontWeight: 500 }}>
                Please Note: To comply with the Data Protection Act 1998 (DPA) personal details entered on accident record forms must be kept confidential.
              </div>
            </div>
              {/* Submit Button */}
              <div className="col-12 text-center mt-4">
                <button type="submit" className="btn btn-lg text-white fw-bold px-5 py-2" style={{ backgroundColor: "#8b1634", borderRadius: "30px", boxShadow: "0 4px 12px rgba(139,22,52,0.3)" }}>Submit</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AccidentReport;
